import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import PdfFlipbook from './PdfFlipbook';

export default function FlipbookModal({ open, onClose, url, title }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    if (open) {
      document.addEventListener('keydown', onKey);
      document.body.style.overflow = 'hidden';
    }
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-[#0b0b0b] flex flex-col" data-testid="flipbook-modal">
      <div className="flex items-center justify-between px-5 md:px-8 h-14 shrink-0 border-b border-white/10">
        <p className="text-white/90 font-medium truncate" data-testid="flipbook-title">{title}</p>
        <button onClick={onClose} data-testid="flipbook-close" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#D01919] text-white flex items-center justify-center transition-colors"><X size={20} /></button>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden px-3 md:px-8 py-4">
        <PdfFlipbook url={url} fill />
      </div>
    </div>
  );
}
